export const USUARIOS_REQUEST = "USUARIOS_REQUEST";
export const USUARIOS_REFRESH = "USUARIOS_REFRESH";
export const USUARIOS_OK = "USUARIOS_OK";
export const USUARIOS_ERROR = "USUARIOS_ERROR";
